const highlights = [
  { icon: 'ri-building-2-line', text: 'Commercial Wind Farms' },
  { icon: 'ri-file-list-3-line', text: 'Corporate PPAs' },
  { icon: 'ri-settings-3-line', text: 'Small Wind Turbines' },
  { icon: 'ri-community-line', text: 'Remote Microgrids' },
];

export default function WindCTA() {
  return (
    <section className="relative overflow-hidden py-20 md:py-28">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Breathtaking%20sunset%20panorama%20of%20Australian%20wind%20farm%20with%20silhouetted%20wind%20turbines%20against%20dramatic%20orange%20and%20purple%20sky%2C%20vast%20outback%20landscape%2C%20cinematic%20wide%20angle%2C%20powerful%20clean%20energy%20imagery%2C%20epic%20landscape%20photography&width=1800&height=700&seq=wind-cta-au-2026&orientation=landscape"
          alt="Australian wind farm at sunset representing the future of clean energy"
          className="w-full h-full object-cover object-center"
          loading="lazy"
        />
        {/* Strong left-to-right dark ramp */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/97 via-black/90 to-black/65" />
        {/* Top + bottom fade */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-black/50" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
        {/* Backdrop panel for guaranteed contrast */}
        <div
          className="max-w-2xl rounded-2xl"
          style={{
            background: 'linear-gradient(135deg, rgba(0,0,0,0.50) 0%, rgba(0,0,0,0.20) 100%)',
            backdropFilter: 'blur(4px)',
            WebkitBackdropFilter: 'blur(4px)',
            padding: '2rem',
          }}
        >
          <div style={{ textShadow: '0 2px 20px rgba(0,0,0,0.90), 0 1px 6px rgba(0,0,0,0.75)' }}>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-500/25 border border-secondary-400/40 mb-6">
              <div className="w-2 h-2 rounded-full bg-secondary-300 animate-pulse-soft" />
              <span className="text-xs font-semibold text-secondary-200 tracking-wide uppercase whitespace-nowrap">Australia&rsquo;s Trusted Renewable Energy Marketplace</span>
            </div>

            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-extrabold text-white leading-tight mb-5">
              Ready to Power Your<br />Business with Wind?
            </h2>

            <p className="text-base md:text-lg text-white leading-relaxed mb-4">
              AK Energy is Australia&rsquo;s trusted renewable energy marketplace, connecting customers, businesses and renewable energy providers to accelerate the transition towards cleaner energy solutions.
            </p>

            <p className="text-sm text-white/75 leading-relaxed mb-8">
              Tell us about your energy needs — whether you&rsquo;re a landowner, a business looking for a PPA, a miner seeking to cut diesel costs, or a community exploring energy independence — and we&rsquo;ll connect you with the right wind energy experts.
            </p>

            {/* Solution tags */}
            <div className="flex flex-wrap gap-2 mb-9">
              {highlights.map((h) => (
                <span
                  key={h.text}
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/15 border border-white/20 text-xs font-semibold text-white whitespace-nowrap"
                >
                  <i className={`${h.icon} text-secondary-300`}></i>
                  {h.text}
                </span>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-3 mb-8">
              <a
                href="/#contact"
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-8 py-4 text-sm font-semibold rounded-xl bg-primary-500 text-white hover:bg-primary-400 transition-all duration-200 cursor-pointer"
              >
                Find Wind Energy Providers
                <i className="ri-arrow-right-line text-lg"></i>
              </a>
              <a
                href="/solar-energy-australia"
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-8 py-4 text-sm font-semibold rounded-xl bg-white/15 border border-white/30 text-white hover:bg-white/25 transition-all duration-200 cursor-pointer"
              >
                <i className="ri-sun-line text-lg"></i>
                Explore Solar Energy Too
              </a>
            </div>

            {/* Cross-link */}
            <p className="text-xs text-white/50">
              Looking for solar energy solutions?{' '}
              <a href="/solar-energy-australia" className="text-white/80 hover:text-white underline underline-offset-2 transition-colors">
                Visit our Solar Energy Australia page
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}